module.exports = __webpack_public_path__ + "static/img/8.439d54b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/eng/8.png
// module id = YT9N
// module chunks = 0